/**
 The next item in the items may be the same as the previous one.
 We need to remove these items.
 **/
export const filterThreadHistoryItems = (input) => {
    /* FYI: Uncomment for testing purposes.
    input.push({id: '06a059a9-d402-72a8-8000-b9fd3a45c2ed', timestamp: new Date().toISOString()});
    input.push({id: '06a059a9-d402-72a8-8000-b9fd3a45c2ed', timestamp: new Date().toISOString()});
    input.push({id: '06a059a9-d402-72a8-8000-b9fd3a45c2ed', timestamp: new Date().toISOString()});*/
    const output = [];
    input.forEach((thread, index) => {
        if (index === 0) {
            output.push(thread);
        }
        else {
            const lastThread = output[output.length - 1];
            if (lastThread.id !== thread.id) {
                output.push(thread);
            }
        }
    });
    return output;
};
//# sourceMappingURL=threads.utils.js.map